import { Link } from "react-router-dom";
import { Phone, Siren, CalendarClock } from "lucide-react";
import { PHONE_TEL } from "@/lib/site";

export default function MobileCTA() {
  return (
    <div data-testid="mobile-cta-bar" className="fixed bottom-0 inset-x-0 z-40 md:hidden border-t border-gold/25 bg-[#0A0A0C]/95 backdrop-blur-md">
      <div className="grid grid-cols-3 divide-x divide-gold/15">
        <a href={PHONE_TEL} data-testid="mobile-bar-call-button" className="flex flex-col items-center gap-1 py-3 text-gold-champagne">
          <Phone size={18} />
          <span className="text-[10px] font-mono-label uppercase tracking-[0.14em]">Call Now</span>
        </a>
        <a href={PHONE_TEL} data-testid="mobile-bar-emergency-button" className="flex flex-col items-center gap-1 py-3 text-red-400">
          <Siren size={18} />
          <span className="text-[10px] font-mono-label uppercase tracking-[0.14em]">Emergency</span>
        </a>
        <Link to="/schedule" data-testid="mobile-bar-schedule-button" className="flex flex-col items-center gap-1 py-3 text-gold-champagne">
          <CalendarClock size={18} />
          <span className="text-[10px] font-mono-label uppercase tracking-[0.14em]">Schedule</span>
        </Link>
      </div>
    </div>
  );
}
